import React from 'react';
import PropTypes from 'prop-types';
import { transformBooleanToYesNo } from 'client/helpers/formikHelpers';

import './SrPdfGeneratorRenterAppAdditionalQuestions.less';

// Test route:
// https://dev.sunroomrentals.com/pdf-generator/renter-app-additional-questions?values=eyJsaXN0aW5nQWRkcmVzcyI6IjEwOSBNYWxsYXJkIExuLCBMZWFuZGVyLCBUWCA3ODY0MSIsImFwcGxpY2FudE5hbWUiOiJEYXZpZCBPbGl2ZXJvcyIsImFwcGxpY2FudFBob25lIjoiODE4MDg4NTIzNSIsImFwcGxpY2FudEVtYWlsIjoiZGF2aWRAc3Vucm9vbXJlbnRhbHMuY29tIiwic3VibWl0dGVkRGF0ZSI6Ikp1bmUgMjksIDIwMjMgYXQgMjoxMnBtIiwic2lnbmF0dXJlVXJsIjoiaHR0cHM6Ly9zMy5hbWF6b25hd3MuY29tL3NyLXRleHQtc2lnbmF0dXJlcy9kYXZpZC1vbGl2ZXJvcy1yZWZlcnJhbC1hZ3JlZW1lbnQtc2lnbmF0dXJlLTBhZWVlY2Q3LTZkODgtNGNmNC04N2I0LWJmN2JkZGQyNWMwYy5qcGciLCJhZGRpdGlvbmFsUXVlc3Rpb25zIjpbeyJ0aXRsZSI6IlRlc3QgRGF0ZSIsInZhbHVlIjoiMjAyMy0wNi0zMFQwNjowMDowMC4wMDBaIn0seyJ0aXRsZSI6IlRlc3QgQm9vbGVhbiIsInZhbHVlIjp0cnVlfSx7InRpdGxlIjoiVGVzdCBMb25nIFRleHQiLCJ2YWx1ZSI6IjQ0In0seyJ0aXRsZSI6IlRlc3QgU2hvcnQgVGV4dCIsInZhbHVlIjoiMTIzIn1dfQ==
const SrPdfGeneratorRenterAppAdditionalQuestions = ({
  listingAddress,
  applicantName,
  applicantPhone,
  applicantEmail,
  submittedDate,
  additionalQuestions,
  signatureUrl,
}) => {
  return (
    <div styleName="root">
      <div styleName="header">
        <div styleName="titlePdf" />
        <div styleName="logo" />
      </div>

      <div styleName="section">
        <span styleName="sectionTitle">Applicant</span>
      </div>
      <div styleName="marginBottom">
        <div>Listing Address: {listingAddress}</div>
        <div>Applicant Name: {applicantName}</div>
        <div>Applicant Phone: {applicantPhone}</div>
        <div>Applicant Email: {applicantEmail}</div>
        <div>Submitted Date: {submittedDate}</div>
      </div>

      <div styleName="section">
        <span styleName="sectionTitle">Additional Rental App Questions</span>
      </div>
      <div styleName="marginBottom">
        {additionalQuestions.map(({ title, value }) => (
          <div styleName="marginBottom" key={title}>
            <div styleName="bold">{title}</div>
            <div>{typeof value === 'boolean' ? transformBooleanToYesNo(value) : value}</div>
          </div>
        ))}
      </div>
      <div styleName="center">
        <img alt="Renter Signature" title="Renter Signature" src={signatureUrl} />
      </div>
    </div>
  );
};

SrPdfGeneratorRenterAppAdditionalQuestions.propTypes = {
  listingAddress: PropTypes.string.isRequired,
  applicantName: PropTypes.string.isRequired,
  applicantPhone: PropTypes.string.isRequired,
  applicantEmail: PropTypes.string.isRequired,
  submittedDate: PropTypes.string.isRequired,
  additionalQuestions: PropTypes.array.isRequired,
  signatureUrl: PropTypes.string.isRequired,
};

SrPdfGeneratorRenterAppAdditionalQuestions.displayName =
  'SrPdfGeneratorRenterAppAdditionalQuestions';

export default SrPdfGeneratorRenterAppAdditionalQuestions;
